import React from 'react';
import Icon from '../../../components/AppIcon';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';

const ClientFilters = ({ filters, onFilterChange }) => {
  const clientTypeOptions = [
    { value: 'all', label: 'Todos los tipos' },
    { value: 'individual', label: 'Individual' },
    { value: 'corporate', label: 'Corporativo' },
    { value: 'fleet', label: 'Flotilla' }
  ];

  return (
    <div className="bg-card rounded-lg border border-border shadow-sm p-4">
      <div className="flex items-center gap-2 mb-4">
        <Icon name="Filter" size={20} className="text-primary" />
        <h3 className="text-sm font-medium text-foreground">Filtros Avanzados</h3>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Tipo de Cliente
          </label>
          <Select
            value={filters?.clientType || 'all'}
            onChange={(e) => onFilterChange({ clientType: e?.target?.value })}
            options={clientTypeOptions}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-foreground mb-2">
            Ingresos Mínimos
          </label>
          <Input
            type="number"
            placeholder="$0"
            value={filters?.minRevenue || ''}
            onChange={(e) => onFilterChange({ minRevenue: e?.target?.value })}
          />
        </div>

        <div className="flex items-end">
          <button
            onClick={() => onFilterChange({ clientType: 'all', minRevenue: '' })}
            className="w-full px-4 py-2 text-sm font-medium text-foreground bg-muted hover:bg-muted/80 rounded-lg transition-smooth flex items-center justify-center gap-2"
          >
            <Icon name="X" size={16} />
            Limpiar Filtros
          </button>
        </div>
      </div>
    </div>
  );
};

export default ClientFilters;